import '../css/UploadVideo.css';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useUser } from '../hooks/useUser';
import { uploadNewVideo, updateUserVideoArray } from '../services/fetch-utils';

export default function UploadVideos() {
  const { user, setUser, isUserProfile } = useUser();

  const [media, setMedia] = useState<File>();
  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');

  const handleMediaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length >= 0) {
      setMedia(e.target.files[0]);
    }
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value);
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDescription(e.target.value);
  };
  const resetInputs = () => {
    setTitle('');
    setDescription('');
    setMedia(undefined);
  };

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    // NOTE: USERS_ID BELOW IS NOT THE SAME AS USER_ID. IT IS THE PROFILE
    // ID. THIS WAS DONE INTENTIONALLY TO MATCH AN INNER JOIN.
    if (user && isUserProfile(user) && media) {
      const newVideo = {
        title,
        description,
        id: user.id,
        username: user.username,
        video: `https://nqbvdgzoxvmdlnjovyqu.supabase.in/storage/v1/object/public/videos/${user?.user_id}/${media.name}`,
        video_name: media.name,
      };

      const upload = uploadNewVideo(newVideo, media, user.user_id)
        .catch((error) => error.message)
        .then(() => updateUserVideoArray(user.user_id))
        .then((res) => {
          if (res.status === 200 && res.data) {
            setUser({ ...user, videos: res.data.videos });
          } else {
            console.log('AN ERROR OCCURED IN UPDATE USER VIDEO ARRAY OF UPLOAD VIDEO');
          }
        })
        .then(() => resetInputs());

      toast.promise(upload, {
        loading: 'Just a moment while we upload your Video',
        success: 'Video successfully uploaded',
        error: 'Oops! Something went wrong. Please try again',
      });
    }
  };

  return (
    <form id="upload-new-media-form" onSubmit={handleSubmit}>
      Upload New Video
      <label className="media-upload-inputs media">
        <input type="file" accept="video/*" onChange={handleMediaChange}></input>
      </label>
      <label className="media-upload-inputs title">
        Title
        <input type="text" value={title} onChange={handleTitleChange}></input>
      </label>
      <label className="media-upload-inputs description">
        Description
        <input type="text" value={description} onChange={handleDescriptionChange}></input>
      </label>
      <button>Submit</button>
    </form>
  );
}
